export default __webpack_public_path__ + "static/levionnoisMarcAntoine-5d51e68d78a380b877bdc3fc44596f21.png";